export var RegionType;
(function (RegionType) {
    RegionType["Button"] = "button";
    RegionType["Divider"] = "divider";
    RegionType["Follow"] = "follow";
    RegionType["Html"] = "html";
    RegionType["Footer"] = "footer";
    RegionType["Image"] = "image";
    RegionType["Link"] = "link";
    RegionType["Logo"] = "logo";
    RegionType["Mix"] = "mix";
    RegionType["Music"] = "music";
    RegionType["Rsvp"] = "rsvp";
    RegionType["ItemGrid"] = "item_grid";
    RegionType["Subscribe"] = "subscribe";
    RegionType["Text"] = "text";
    RegionType["Video"] = "video";
    RegionType["WixFooter"] = "wix_footer";
})(RegionType || (RegionType = {}));
export var SocialFollowButtons;
(function (SocialFollowButtons) {
    SocialFollowButtons["facebook"] = "facebook";
    SocialFollowButtons["instagram"] = "instagram";
    SocialFollowButtons["linkedIn"] = "linkedIn";
    SocialFollowButtons["pinterest"] = "pinterest";
    SocialFollowButtons["soundCloud"] = "soundCloud";
    SocialFollowButtons["twitter"] = "twitter";
    SocialFollowButtons["youtube"] = "youtube";
    SocialFollowButtons["tiktok"] = "tiktok";
})(SocialFollowButtons || (SocialFollowButtons = {}));
export var LogoType;
(function (LogoType) {
    LogoType["custom"] = "custom";
    LogoType["siteLogo"] = "siteLogo";
    LogoType["wixStudio"] = "wixStudio";
    LogoType["wixClassic"] = "wixClassic";
    LogoType["wixPayments"] = "wixPayments";
    LogoType["wixVibe"] = "wixVibe";
    LogoType["marketplace"] = "marketplace";
    LogoType["rise"] = "rise";
})(LogoType || (LogoType = {}));
export var WixComponentTypes;
(function (WixComponentTypes) {
    WixComponentTypes["classic"] = "wix_classic";
    WixComponentTypes["studio"] = "wix_studio";
    WixComponentTypes["payments"] = "wix_payments";
    WixComponentTypes["rise"] = "rise";
})(WixComponentTypes || (WixComponentTypes = {}));
//# sourceMappingURL=types.js.map